import React, { memo } from 'react';

const FAQSection = () => {
    const faqs = [
        {
            q: "What is a case number and where do I find it?",
            a: "Your lender shares a case number. Check your lender’s email invite or portal message and paste it here.",
        },

        {
            q: "Is my data secure?",
            a: "Yes. Files are encrypted in transit and stored securely. We only use them to help your lender underwrite your loan.",
        },
        {
            q: "Which documents should I have ready?",
            a: "Government ID, recent pay stubs, W-2s/tax returns, recent bank statements, and any mortgage or loan statements you have.",
        },
        {
            q: "How long does it take after I upload?",
            a: "Most lenders review within hours. If anything else is needed, they’ll let you know in this portal.",
        },
    ];

    return (
        <div
            style={{
                margin: "0 0 28px",
                background: "rgba(15,23,42,0.86)",
                borderRadius: "16px",
                border: "1px solid rgba(148,163,184,0.25)",
                padding: "20px",
                boxShadow: "0 18px 60px rgba(8,12,24,0.45)",
            }}
        >
            <h3
                style={{
                    margin: "0 0 12px",
                    fontSize: "18px",
                    color: "#e2e8f0",
                    fontWeight: 800,
                    letterSpacing: "-0.01em",
                }}
            >
                FAQs
            </h3>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", textAlign: "left" }}>
                {faqs.map((item, idx) => (
                    <details
                        key={item.q}
                        style={{
                            background: "rgba(255,255,255,0.02)",
                            border: "1px solid rgba(148,163,184,0.2)",
                            borderRadius: "12px",
                            padding: "12px 14px",
                            color: "#e2e8f0",
                            textAlign: "left",
                            listStyle: "none",
                        }}
                    >
                        <summary
                            style={{
                                cursor: "pointer",
                                fontWeight: 700,
                                fontSize: "14px",
                                outline: "none",
                                listStyle: "none",
                            }}
                        >
                            {idx + 1}. {item.q}
                        </summary>
                        <p style={{ margin: "10px 0 0", fontSize: "13px", color: "#cbd5e1", lineHeight: 1.5 }}>{item.a}</p>
                    </details>
                ))}
            </div>
        </div>
    );
};

export default memo(FAQSection);
